import React from 'react'
import { Box, Container, makeStyles, Typography } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  container: {
    paddingTop: theme.spacing(9),
    paddingBottom: theme.spacing(9),
  },
  subtitle: {
    color: theme.palette.grey[500],
    textTransform: 'none',
  },
  containerWithoutPadding: {
    paddingTop: theme.spacing(9),
    paddingBottom: theme.spacing(9),
    paddingLeft: 0,
    paddingRight: 0,
  },
  printPadding: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
  },
}))

type Props = {
  title?: string
  subtitle?: string
  addon?: React.ReactNode
  children: React.ReactNode
  omitPadding?: boolean
  printPadding?: boolean
  maxWidth?: false | 'xs' | 'sm' | 'md' | 'lg' | 'xl'
}

export function Section({
  title,
  subtitle,
  addon,
  children,
  omitPadding,
  printPadding,
  maxWidth = 'lg',
}: Props): React.ReactElement {
  const classes = useStyles()

  const getContainerStyle = () => {
    if (omitPadding) {
      return classes.containerWithoutPadding
    }
    if (printPadding) {
      return classes.printPadding
    }
    return classes.container
  }

  return (
    <Container className={getContainerStyle()} maxWidth={maxWidth}>
      {title && (
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          mb={4}
        >
          {subtitle ? (
            <Box display="flex" flexDirection="column">
              <Typography variant="h5">{title}</Typography>
              <Typography variant="subtitle1" className={classes.subtitle}>
                {subtitle}
              </Typography>
            </Box>
          ) : (
            <Typography variant="h5">{title}</Typography>
          )}

          {addon}
        </Box>
      )}

      {children}
    </Container>
  )
}
